export const app = {
  namespaced: true,

  state: {
    maintenance_enabled: false,
  },
};